<template>
    <v-dialog v-model="shows" width="100%" max-width="720" content-class="rounded-lg">
        <template #activator="{ attrs, on }">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>
        <v-sheet class="full-height">

            <v-layout column fill-height>
                <bottom-sheet-header style="position: relative">
                    성차별금지 주요내용
                    <v-btn small text fab tile absolute right color="white" @click="shows = false"> <v-icon>mdi-close</v-icon> </v-btn>
                </bottom-sheet-header>
            
                <v-sheet class="scroll-primary py-40 px-60" style="flex: 1 1 auto; overflow-y: auto">
                    <p class="page-text mb-12 mb-lg-20">
                        모집·채용에서 남녀를 차별하거나, 여성근로자를 채용할 때 직무수행에 불필요한 용모, 키, 체중 등의 신체조건, 미혼조건을 제시 또는 요구하는 경우는 남녀고용평등과 일·가정 양립 지원에 관한 법률 위반에 따른 500만원 이하의 벌금이 부과될 수 있습니다.
                    </p>
                    <vertical-table v-bind="{ items }">
                        <template slot="차별사례">
                            <ul>
                                <li class="mb-4">· 특정성을 지칭하는 직종명 등 사용하는 경우, 특정성 배제<br />남성 선반공, 병역필 남, 여성 비서, 미용사(여성 환영) 등</li>
                                <li>· 직종 등 남녀 분리모집 등<br />관리ㆍ사무직 남성 10명, 판매직 여성 5명</li>
                            </ul>
                        </template>
                        <template slot="차별로 보지 않는 사례">
                            <ul>
                                <li class="mb-4">· 직무성질상 특정한 성이 불가피한 경우<br />남성역할 위한 배우ㆍ모델 등<br />여성 목욕탕의 여성 목욕관리사, 여성 장애인ㆍ여성 환자의 도우미 등<br />여성 기숙사의 여성사감 등</li>
                                <li>· 현존하는 차별 없애거나 고용평등 촉진위해 잠정적으로 특정성 우대하는 조치를 하는 경우 등</li>
                            </ul>
                        </template>
                    </vertical-table>
                </v-sheet>
            </v-layout>
        </v-sheet>
    </v-dialog>
</template>

<script>
import VerticalTable from "@/components/dumb/vertical-table.vue";
import BottomSheetHeader from "@/components/dumb/bottom-sheet-header.vue";

const items = [
    {
        term: "관련법령",
        data: `남녀고용평등과 일·가정 양립 지원에 관한 법률
제7조 제1항에 의거 근로자를 모집하거나 채용 시 합리적인 이유 없이 남녀를 차별할 수 없음
<차별 시 500만원 이하 벌금>`,
    },
    { term: "차별사례" },
    { term: "차별로 보지 않는 사례" },
];

export default {
    components: { VerticalTable, BottomSheetHeader, },
    data: () => ({
        shows: false,
        items,
    }),
};
</script>

<style>
</style>